import { Lesson } from '@/models/lesson';
import { CustomSession } from '@/providers/session/type';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { AppBar, AppBarProps, Divider, IconButton, Toolbar, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { ContextualItem } from '../../type';

export type ContextualToolbarProps = AppBarProps & {
    user: CustomSession['user'];
    items: ContextualItem[];
    onClearSelection?: () => void;
    onRemoveItems?: (items: ContextualItem[]) => void;
    onMoveItems?: (items: ContextualItem[]) => void;
};

export const ContextualToolbar: React.FC<ContextualToolbarProps> = ({ user, items, onClearSelection, onRemoveItems, onMoveItems }) => {
    const tprofile = user?.teacherProfile;

    return (
        <AppBar position='sticky' color='inherit' sx={{ top: 16, borderRadius: 0.5, px: 1, zIndex: (theme) => theme.zIndex.appBar }}>
            <Toolbar variant='dense' disableGutters>
                <IconButton size='small' color='inherit' onClick={onClearSelection}>
                    <CloseIcon />
                </IconButton>

                <Typography variant='subtitle2' color='inherit' sx={{ ml: 0.5, mr: 2 }}>
                    <Trans
                        i18nKey='lesson.contextual.selected'
                        values={{ num: items.length }}
                        components={{ span: <span style={{ width: String(items.length).length + 'ch', display: 'inline-block', textAlign: 'center' }} />, bold: <strong /> }}
                    />
                </Typography>

                <Divider orientation='vertical' flexItem sx={{ mx: 1 }} />

                <IconButton
                    size='small'
                    color='inherit'
                    disabled={!items.every((item) => item instanceof Lesson) || !tprofile || items.some((item) => !item.isOwnedBy(tprofile))}
                    onClick={() => onMoveItems?.(items)}
                >
                    <DriveFileMoveIcon />
                </IconButton>

                <Divider orientation='vertical' flexItem sx={{ mx: 1 }} />

                <IconButton size='small' color='inherit' disabled={items.length === 0} onClick={() => onRemoveItems?.(items)}>
                    <DeleteIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};
